(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('isAutofocus', isAutofocus); 

        isAutofocus.$inject = ['$timeout', '$rootScope'];

    function isAutofocus($timeout, $rootScope) {
        
        return {
            restrict: 'A',
            link: function(scope, element, attrs){
                var c = element.attr('is-autofocus');
                $timeout(function () {
                    if(attrs.hasOwnProperty('isAutofocus') && 
                    (attrs.isAutofocus === 'true' || attrs.isAutofocus === '')){ 
                        element[0].focus();
                    }
                }, 0);

                var deregister = $rootScope.$on('tab-opened', function (event, args) {
                    $timeout(function () {
                        if(attrs.hasOwnProperty('isAutofocus') && 
                        (attrs.isAutofocus === 'true' || attrs.isAutofocus === '')){
                            element[0].focus();
                        }
                    }, 0);
                });

                scope.$on('$destroy', function() {
                    deregister();
                });
            }
        };
    }
})();